import { useEffect, useState } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import "../../Styles/Login.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { Link, useNavigate } from "react-router-dom";
import { forgetPassword, getEmployeeRolePermission, loginAdmin, resetPassword } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { loginSuccess } from "../../Redux/user_information";
import { useDispatch } from "react-redux";
import { getDeviceToken } from "../../Services/firebaseAuth";

export default function LoginPage() {
  const [formData, setFormData] = useState({ email: "", password: "",deviceType:"WEB",deviceToken:""});
  const[load,setLoad]=useState(false)
   const[rolePermission,setRolePermission]=useState([])
   const[tokenInput,setTokenInput]=useState("")
   const[newPassword,setNewPassword]=useState("")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const[mode,setMode]=useState(1)
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

    const fetchEmployeeRolePermission = async (token) => {
            try {
              const response = await getEmployeeRolePermission(token);
              console.log("Employee role permission:", response.data);
              setRolePermission(response.data);
              return response.data
             
            } catch (error) {
              console.error("Error updating profile:", error);
              return null;
            }
          };

          const handleForgetPassword=async()=>{
            if(formData.email===''){
              toast.info("Enter Email id")
              return
            }
            let data={
              email:formData.email
              
            }
            try {
              const response=await forgetPassword(data)
              console.log(response);
              if(response.status=200){
                toast.success('Password reset link sent to your email')
                setMode(2)
              }
              
            } catch (error) {
              console.log(error);
              
            }
          }

              const handleResetPassword=async(e)=>{
                  e.preventDefault();
            if(tokenInput===''|| newPassword===" "){
              toast.info("Enter required filed")
              return
            }
            let data={
             token:tokenInput,
             newPassword
              
            }
            try {
              setLoad(true)
              const response=await resetPassword(data)
              console.log(response);
              if(response.status=200){
                toast.success('Password changed successfully')
                setMode(1)
              }
              
            } catch (error) {
              console.log(error);
              
            }finally{setLoad(false)}
          }

        
          
          

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoad(true)

        const devicetoken= await getDeviceToken();
        formData.deviceToken=devicetoken;

        // const newForm= new FormData()
        // newForm.append("email",formData.email)
        // newForm.append("password",formData.user_pass)
        // newForm.append("deviceType",formData.deviceType)
        // newForm.append("deviceToken",formData.deviceToken)



        console.log("login : ",formData)
      const response = await loginAdmin(formData);
      console.log("login response",response);
      
      
      if (response.status === 200) {
      
      let permissionList=await  fetchEmployeeRolePermission(response.data.data.token)
        console.log("role",response.data.data.employee_role_id);
        
     if(permissionList){
      const roleId=permissionList.find(item=>item.roleId===response.data.data.employee_role_id) 
      console.log("employee role",roleId);
        dispatch(
          loginSuccess({
            token: response.data.data.token,
            role: response.data.data.role_id,
            empId:JSON.stringify(roleId)
          })
        );
     }else{
       dispatch(
          loginSuccess({
            token: response.data.data.token,
            role: response.data.data.role_id,
            empId:null
          })
        );
     }
        
 
      
      
  
        toast.success("Login successful");
  
        // setTimeout(() => {
          navigate("/")
        // }, 1000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to login")
    }finally{
      setLoad(false)
    }
  };
  
  

  return (
    <div className="main-section1">


    {mode===1 ?  <div className="login-container">
        <h2 className="login-title">Welcome Back</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group1">
            <label>Email Address</label>
            <div className="input-container">
              <FaUser className="icon" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div className="input-group1">
            <label>Password</label>
            <div className="input-container">
              <FaLock className="icon" />
              <input
                type="password"
                name="password"
                autoComplete="new-password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
            </div>
          </div>
         {load? <button type="submit" className="login-button" style={{cursor:"not-allowed"}}>
            running..
          </button>
          :
          <button type="submit" className="login-button">
            Login
          </button>}
        </form>

        <div className="extra-links">
          <p>
            Don't have an account? <Link to="/signup">Sign up</Link>
          </p>
          <p>
            <Link to="#"
            onClick={handleForgetPassword}>Forgot Password?</Link>
          </p>
        </div>
      </div>
      :
       <div className="login-container">
        <h2 className="login-title">Reset Password</h2>

        <p style={{fontSize:"15px",color:"red",fontWeight:"700"}}>*Enter the token value from the link send to email</p>
        <form >
          <div className="input-group1">
            <label>Token</label>
            <div className="input-container">
              <FaUser className="icon" />
              <input
                type="test"
                
                value={tokenInput}
                onChange={(e)=>setTokenInput(e.target.value)}
                placeholder="Enter token send to email"
                required
              />
            </div>
          </div>

          <div className="input-group1">
            <label> New Password</label>
            <div className="input-container">
              <FaLock className="icon" />
              <input
                type="password"
                name="password"
                autoComplete="new-password"
                value={newPassword}
                onChange={(e)=>setNewPassword(e.target.value)}
                placeholder="Enter new password"
                required
              />
            </div>
          </div>
         {load? <button type="submit" className="login-button" style={{cursor:"not-allowed"}}>
            running..
          </button>
          :
          <button type="submit" className="login-button"
          onClick={handleResetPassword}>
            Reset
          </button>}
        </form>

        
      </div>
    }
    </div>
  );
}
